import { render, staticRenderFns } from "./Errors.vue?vue&type=template&id=2867ce59"
import script from "./Errors.vue?vue&type=script&lang=js"
export * from "./Errors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/booking-staging.greenmotion.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2867ce59')) {
      api.createRecord('2867ce59', component.options)
    } else {
      api.reload('2867ce59', component.options)
    }
    module.hot.accept("./Errors.vue?vue&type=template&id=2867ce59", function () {
      api.rerender('2867ce59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/apps/shared/components/ui/Errors.vue"
export default component.exports